import { render, staticRenderFns } from "./zone-header.vue?vue&type=template&id=49c64016&scoped=true"
import script from "./zone-header.vue?vue&type=script&lang=js"
export * from "./zone-header.vue?vue&type=script&lang=js"
import style0 from "../../assets/commoon/css/common.css?vue&type=style&index=0&id=49c64016&prod&scoped=true&lang=css&external"
import style1 from "./zone-header.vue?vue&type=style&index=1&id=49c64016&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c64016",
  null
  
)

export default component.exports